var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV6CatalogIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 5.625H4.375V7.5H5.625H19.375H20.625V5.625ZM21.25 9.375H20.625H19.375H5.625H4.375H3.75H2.5V7.5V5.625V3.75H4.375H20.625H22.5V5.625V7.5V9.375H21.25ZM8.75 11.25H9.6875H15.3125H16.25V13.125H15.3125H9.6875H8.75V11.25ZM19.375 10.625H21.25V19.375V21.25H19.375H5.625H3.75V19.375V10.625H5.625V19.375H19.375V10.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV6CatalogIcon);
export default __webpack_public_path__ + "static/media/v6-catalog-icon.731b30d2bb3eb1327562a53cf26db850.svg";
export { ForwardRef as ReactComponent };